import ScrollListener from "./util/ScrollListener";

const stickyNav = () => {
    const nav = document.querySelector('nav');
    const navMenu : HTMLElement = document.querySelector(".nav-menu")
    const setStickyNav = (addMargin: number) => {
        if (document.body.getAttribute('data-nav-sticky') === 'true') return
        if (document.body.getAttribute('data-nav-open') === 'true') return


        document.body.setAttribute('data-nav-sticky', 'true')
        // document.body.style.marginTop = addMargin + 'px'
    }

    const unsetStickyNav = () => {
        if (document.body.getAttribute('data-nav-sticky') !== 'true') return
        document.body.setAttribute('data-nav-sticky', 'false')
        // document.body.style.marginTop = "13rem"
    }

    const checkPosition = () => {
        const breakpoint = (nav?.offsetHeight + navMenu?.offsetHeight)
        const addMargin = (navMenu?.offsetHeight / 3)
        const scrollTop = window.scrollY || document.documentElement.scrollTop

        if (scrollTop > breakpoint) setStickyNav(addMargin)
        else  unsetStickyNav()
    }

    const scrollListener = new ScrollListener(window)
    scrollListener.attachListener(checkPosition)

    window.addEventListener('resize', checkPosition)
    checkPosition()


    // const closeBtn = document.querySelector("div.close-button-container");
    //
    // function handleCloseBtn() {
    //     console.log("click")
    //     if (document.body.getAttribute("widget-closed") === "true") return;
    //
    //     document.body.setAttribute("widget-closed", "true");
    // }
    //
    // closeBtn.addEventListener("click", handleCloseBtn);
}
export default stickyNav